import { Theme } from '@mui/material';



export const customGray = {
  light: '#F9F9FB',
  main: '#E7E9EF',
  dark: '#56626E',
  darker: '#1E1F23',
  contrastText: '#28292C'
} as const;


export const primaryColor = {
  light: '#E7F5F3',
  main: '#197C85',
  dark: '#10B99F',
  darker: '#849DA1',
  contrastText: '#FFFFFF'
} as const;

export const secondaryColor = {
  light: '#FDFDFF',
  main: '#F8F8FB',
  dark: '#E4E6E9',
  darker: '#1E1F23',
  contrastText: '#197C85'
} as const;

const background = {
  default: '#EEF4F6',
  paper: '#FFF'
} as const;

export const successColor = {
  light: '#cdfff9',
  main: '#94C800',
  dark: '#10A969',
  darker: '#039440',
  contrastText: '#fff'
} as const;

export const errorColor = {
  light: '#FFF3F5',
  main: '#D83B57',
  dark: '#97293C',
  contrastText: '#fff'
} as const;

export const warningColor = {
  light: '#FFF5ED',
  main: '#EB8D19',
  dark: '#F15A05',
  darker: '#FF5C00',
  contrastText: 'fff'
} as const;

export const infoColor = {
  light: '#F1F5FE',
  main: '#3266E0',
  dark: '#23479c',
  contrastText: '#fff'

} as const;

export const purple = {
  light: '#F3ECFF',
  main: '#6C13FF',
  dark: '#4B0DB2',
  contrastText: '#fff'
} as const;

export const yellow = {
  light: '#FFF4D8',
  main: '#FFC83C',
  dark: '#F5B612',
  contrastText: '#fff'
};

export const palette: Partial<Theme['palette']> = {
  background: {
    ...background
  },
  primary: {
    ...primaryColor
  },
  customGray: {
    ...customGray
  },
  secondary: {
    ...secondaryColor
  },
  success: {
    ...successColor
  },
  error: {
    ...errorColor
  },
  info: {
    ...infoColor
  },
  warning: {
    ...warningColor
  },
  purple: {
    ...purple
  }
} as const;
